import { render, staticRenderFns } from "./FakeTraceDialog.vue?vue&type=template&id=4048fa96&scoped=true"
import script from "./FakeTraceDialog.vue?vue&type=script&lang=js"
export * from "./FakeTraceDialog.vue?vue&type=script&lang=js"
import style0 from "./FakeTraceDialog.vue?vue&type=style&index=0&id=4048fa96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048fa96",
  null
  
)

export default component.exports